import { FieldErrors } from "react-hook-form";

import { FormFieldLabel } from "src/cases/caseView/components/FormFieldLabel";
import { CaseTemplateFormFieldsInner } from "src/clients/case-management";
import { ErrorHint } from "src/design-system/ErrorHint";

type ActionFormFieldGroupProps = {
  field: CaseTemplateFormFieldsInner;
  errors?: FieldErrors;
  children: React.ReactNode;
};

export const ActionFormFieldGroup: React.FC<ActionFormFieldGroupProps> = ({
  field,
  errors,
  children,
}) => (
  <>
    <FormFieldLabel field={field} />
    {children}
    {errors?.[field.key]?.message != null && (
      <ErrorHint>{String(errors[field.key]?.message)}</ErrorHint>
    )}
  </>
);
